export const DEFAULT_ROTATE_ANGLES = [ 0 ];

export const DEFAULT_DRAW_OUT_OF_BOUND = "hidden";

export const DEFAULT_MIN_FONT_SIZE = 20;

export const DEFAULT_FONTSIZE_RANGE = [ 20, 40 ];

export const DEFAULT_FONT_WEIGHT_RANGE = [ 200, 500 ];

export const DEFAULT_MASK_SHAPE = "circle";

export const DEFAULT_ZOOM_TO_FIT = {
    shrink: !1,
    enlarge: !1,
    fontSizeLimitMin: 0
};

export const DEFAULT_RANDOM = !0;

export const DEFAULT_FONT_PADDING = 1;

export const DEFAULT_TEXT_ALIGN = "center";

export const DEFAULT_TEXT_BASE_LINE = "alphabetic";

export const SHAPE_TYPE = [ "triangleForward", "triangle", "diamond", "square", "star", "cardioid", "circle", "pentagon", "rect" ];
//# sourceMappingURL=config.js.map
